import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import Grid from '@components/basics/grid';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import Percentage from '@components/dashboard/metrics-widget/percentage';

import { numberFormatter } from './utils';
import styled from 'styled-components';

export interface ComparativeItemType {
  label: string;
  value: number;
  percentage: number;
  streams: number;
}

interface ComparativeItemProps {
  className?: string;
  item: ComparativeItemType;
  isMobile?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const ComparativeItem: FunctionComponent<ComparativeItemProps> = ({
  className,
  item,
}) => {
  return (
    <Flex
      className={className || ''}
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Typography customFont="semi-bold">{item.label}</Typography>
      <Flex justifyContent="flex-end" alignItems="flex-start" gap={5}>
        <Grid noGap>
          <Typography type="small" weight="700" align="right">
            {numberFormatter.format(item.streams)}
          </Typography>
          <Typography type="small" isGrey align="right">
            <Translate id="ANALYTICS.ENGAGEMENT.ACTIVITY.ITEMS.STREAMS" />
          </Typography>
        </Grid>
        <Percentage
          className="percentage"
          value={item.percentage}
          valueFormat="percentage"
          noBackground
        />
      </Flex>
    </Flex>
  );
};

export default connect(mapStateToProps)(styled(ComparativeItem)`
  .percentage {
    min-width: 40px;
    text-align: right;
  }
`);
